const light = {
  primary_color: "#0D8A6A",
  text_color: "#000000",
  body: "#F6F6F6",
  text: "#363537",
  ticker: {
    background_color: "#F9FAFB",
    border_bottom: "1px solid #F1F1F4",
    circle_fill: "#2E2E33",
  },
  tooltip: {
    background: "rgba(255, 255, 255, 0.87)",
    text: "#000000",
  },
  dropdown: {
    background_color: "#ffffff",
    color: "#000",
    disabled: {
      color: "#b2b2b2",
      background: "#dadada",
    },
  },
  date_range_picker: {
    preset: {
      color: "#000000",
      background: "#fafafa",
      custom_button: "#e2f0db",
      hover: "#e1e1e1",
    },
    custom: {
      color: "#000000",
      background: "#f6f6f6",
      border: "1px solid #f6f6f6",
    },
  },
  button: {
    primary_color: "#0D8A6A",
    primary_border_color: "#36474e",
  },
  button_plain: {
    text: "#363537",
    background: "#ffffff",
    border: "#363537",
    hover: "#DADDE2",
    hover_text: "#363537",
  },
  background: "#E5E5E5",
  widget: {
    background: "#ffffff",
    tableHeader: "#D8EDEA",
    outline: "#acd5ca",
  },
  widget_group: {
    background: "#F0F0F0",
    border: "#F0F0F0",
    tableHeader: "#D8EDEA",
    outline: "#acd5ca",
  },
  modal: {
    background: "#ffffff",
    text: "#000",
    hover: "#b3b3b3"
  },
  pivot_table: {
    background_color: "#ffffff",
    field_list_props: {
      border_color: "#b3b3b3 ",
    },
    table_props: {
      border_color: "#292929",
      header_background_color: "#ececec",
    },
    calculated_field_props: {
      background_color: "#ffffff",
      input_field_background_color: "#fff",
    },
    chart_props: {
      label_color: "#050505",
    },
  },
  bs_title: "#D8EDEA",
  border_color: "#e9e9e9",
  tableBorder: "#B0BEC5",
  resetBorder: "#ffffff",
  partition_line: "1px solid #f2f2f2",
  table_cell_border: "#ececec",
  sticky_nav: "#fff",
  recommendation_note: {
    background: "#f9f9f9",
  },
  filter: {
    background: "#464646",
    color: "#363537",
  },
  happenings: {
    card: {
      background: "#FAF9F9",
    },
    positive: {
      icon: {
        color: "#0000004d",
        background: "#c5def6",
      },
      title: "#4190da",
      message: "#6AA4DB",
      time: "#6AA4DB",
    },
    neutral: {
      icon: {
        color: "#0000004d",
        background: "#ebebeb",
      },
      title: "#808480b2",
      message: "#808480",
      time: "#808480",
    },
    negative: {
      icon: {
        color: "#0000004d",
        background: "#f7bdbd",
      },
      title: "#c5616180",
      message: "#c56161",
      time: "#c56161",
    },
  },
  datepicker: {
    cancelButton: {
      background: "#eceff1",
      border: "#b0bec5",
      text: "#363537"
    }
  },
  theme_toggle_option: '#FCFBF5',
  // Sapaad Signals — see PRD §8 "Frontend Design".
  // Red = Act Now (true red). Amber = Ready to Act (brand orange from mockup).
  // Green = Relax. Amber and red must stay visually distinct.
  signals: {
    page_bg:           "#f7f5f1",
    card_bg:           "#ffffff",
    card_border:       "#ebe6dd",
    card_shadow:       "0 1px 2px rgba(20, 18, 12, 0.04)",
    text_primary:      "#1a1a1a",
    text_secondary:    "#5d5a51",
    text_muted:        "#8a8579",
    eyebrow:           "#a39d8e",
    divider:           "#ece8df",
    chip_bg:           "#f4f0e8",
    badge_text:        "#ffffff",
    live_dot:          "#1e8c4a",
    red_strong:        "#f9364a",
    red_tint:          "#feeef0",
    red_text:          "#991b1b",
    amber_strong:      "#e07b00",
    amber_tint:        "#fdf1de",
    amber_text:        "#8a4b00",
    green_strong:      "#1e8c4a",
    green_tint:        "#e3f3e9",
    green_text:        "#0e5b2c",
    neutral_strong:    "#8a8579",
    neutral_tint:      "#f0ece4",
    neutral_text:      "#5d5a51"
  }
};

const dark = {
  primary_color: "#0D8A6A",
  text_color: "#000000",
  body: "#363537",
  text: "#d6d6d6",
  ticker: {
    background_color: "#444445",
    border_bottom: "1px solid #4c4c4d",
    circle_fill: "#6d6d6d",
  },
  tooltip: {
    background: "rgba(0, 0, 0, 0.87)",
    text: "#ffffff",
  },
  dropdown: {
    background_color: "#212121",
    color: "#fff",
    disabled: {
      color: "#969696",
      background: "#2d2d2d",
    },
  },
  date_range_picker: {
    preset: {
      color: "#ffffff",
      background: "#353535",
      custom_button: "#9bad91",
      hover: "#6e6e6e",
    },
    custom: {
      color: "#ffffff",
      background: "#212121",
      border: "1px solid #383636",
    },
  },
  button: {
    primary_color: "#0D8A6A",
    primary_border_color: "#36474e",
  },
  button_plain: {
    text: "#ffffff",
    background: "#212121",
    border: "#ffffff",
    hover: "#474747",
    hover_text: "#ffffff",
  },
  background: "#212121",
  widget: {
    background: "#212121",
    tableHeader: "#212121",
    outline: "#3e7667",
  },
  widget_group: {
    background: "#2a2a2a",
    border: "#2a2a2a",
    tableHeader: "#D8EDEA",
    outline: "#acd5ca",
  },
  modal: {
    background: "#212121",
    text: "#ffffff",
    hover: "#6d6d6d"
  },
  pivot_table: {
    background_color: "#333333",
    field_list_props: {
      border_color: "#ffffff"
    },
    calculated_field_props: {
      background_color: "#333333",
      input_field_background_color: "#272727",
    },
    table_props: {
      border_color: "#4e4c4c",
      header_background_color: "#2c2c2c",
    },
    chart_props: {
      label_color: "#ffffff",
    },
  },
  border_color: "#4e4c4c",
  tableBorder: "#363537",
  resetBorder: "#ffffff",
  bs_title: "#6B6B6B",
  partition_line: "1px solid #323232",
  table_cell_border: "#2e2e2e",
  sticky_nav: "#413f3f",
  recommendation_note: {
    background: "#282828",
  },
  filter: {
    background: "#e1e7ec",
    color: "#b4bec6",
  },
  happenings: {
    card: {
      background: "#272727",
    },
    positive: {
      icon: {
        color: "#6AA4DB",
        background: "#2a3e50",
      },
      title: "#4190da",
      message: "#6AA4DB",
      time: "#6AA4DB",
    },
    neutral: {
      icon: {
        color: "#808480",
        background: "#2f2f2fe3",
      },
      title: "#808480b2",
      message: "#808480",
      time: "#808480",
    },
    negative: {
      icon: {
        color: "#c56161",
        background: "#332626",
      },
      title: "#c5616180",
      message: "#c56161",
      time: "#c56161",
    },
  },
  datepicker: {
    cancelButton: {
      background: "#3a3a3a",
      border: "#4e4c4c",
      text: "#d6d6d6"
    }
  },
  theme_toggle_option: '#212121',
  // Sapaad Signals — dark counterpart. Red = Act Now; amber = Ready to Act
  // (brand orange, same hue family as the light mockup).
  signals: {
    page_bg:           "#161618",
    card_bg:           "#1f1d22",
    card_border:       "#2a282e",
    card_shadow:       "0 1px 2px rgba(0, 0, 0, 0.35)",
    text_primary:      "#ededed",
    text_secondary:    "#b3b1ad",
    text_muted:        "#7a7872",
    eyebrow:           "#8a8783",
    divider:           "#2a282e",
    chip_bg:           "#26242a",
    badge_text:        "#ffffff",
    live_dot:          "#3ecf7e",
    red_strong:        "#f9364a",
    red_tint:          "#2c1515",
    red_text:          "#fca5a5",
    amber_strong:      "#e07b00",
    amber_tint:        "#3a2c12",
    amber_text:        "#ffd591",
    green_strong:      "#3ecf7e",
    green_tint:        "#163325",
    green_text:        "#9ee6bd",
    neutral_strong:    "#7a7872",
    neutral_tint:      "#26242a",
    neutral_text:      "#b3b1ad"
  }
};

const vars = {
  navbar_height: "80px",
};

// combine light and dark themes with vars
const themes = {
  light: { ...light, vars },
  dark: { ...dark, vars },
};

export const lightTheme = themes.light;
export const darkTheme = themes.dark;
